<script setup lang="ts">
const props = defineProps({
  isCategoryBanner: {
    type: Boolean,
    required: false,
    default: () => false,
  },
})

const { isDesktop } = useDevice()
</script>

<template>
  <div class="banner" :class="{ 'category--banner': props.isCategoryBanner }">
    <div class="banner__image" />
    <div v-if="isDesktop" class="banner__image" />
    <div v-if="isDesktop" class="banner__image" />
  </div>
</template>

<style lang="scss" scoped>
.category--banner {
  height: 150px !important;
  border-radius: 20px;
}

.banner {
  position: relative;
  display: flex;
  width: 100%;
  height: inherit;
  overflow: hidden;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: '';
    background-image: linear-gradient(
      90deg,
      rgba(#fff, 0) 0,
      rgba(#fff, 0.2) 20%,
      rgba(#fff, 0.2) 60%,
      rgba(#fff, 0)
    );
    transform: translateX(-100%);
    animation: shimmer 2s infinite;
  }

  &__image {
    width: 100%;
    padding-bottom: 39.07305%;
    background-color: $button-background;
    border-radius: 20px;

    @include media('>=desktop') {
      width: 392px;
      height: 154px !important;
      padding-bottom: 0;
      margin-left: 12px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
